<form [formGroup]="form" id="form-component">
  <div class="row">
    <div
      [class]="question.class"
      [ngClass]="{ 'not-required': !question.required }"
      *ngFor="let question of questions"
    >
      <ng-container
        *ngIf="question.type === 'radiogroup' && question.isVisible !== false"
      >
        <label
          [innerHtml]="question.title | translate"
          class="font-inter"
        ></label>
        <div
          *ngFor="let choice of question.choices; let i = index"
          class="radio radio-primary m-b-10 m-l-10"
          [style]="
            question.isDisabled
              ? 'pointer-events: none !important; cursor: not-allowed !important; opacity: 0.5 !important;'
              : ''
          "
        >
          <input
            [formControlName]="question.key"
            [id]="question.title + i"
            type="radio"
            [value]="choice.value"
            [matTooltip]="question?.tooltip?.fieldText | translate"
            [disabled]="question.isDisabled || false"
          />
          <label class="mb-0 font-inter" [for]="question.title + i">
            &nbsp;{{ choice.title | translate }}
            <img
              src="../../../../assets/images/payment-methods/{{
                choice.srcImage
              }}.png"
              alt=""
              *ngIf="choice.srcImage"
            />
          </label>
        </div>
      </ng-container>
      <ng-container
        class="pb-0"
        *ngIf="question.type === 'select' && question.isVisible !== false"
      >
        <div
          class="field-height"
          [class]="
            !form.controls[question.key].valid &&
            form.controls[question.key].touched
              ? 'is-invalid'
              : ''
          "
        >
          <mat-label
            >{{ question.title | translate }}
            <span *ngIf="question.required" class="danger">*</span></mat-label
          >
          <mat-select
            [id]="question.key"
            [formControlName]="question.key"
            [value]="question.value"
            [placeholder]="(question.placeholder | translate) || ''"
            [matTooltip]="question?.tooltip?.fieldText | translate"
            (opened)="selectOpenedHandler(question)"
            (closed)="selectClosedHandler(question)"
            class="form-control"
            [class]="
              !form.controls[question.key].valid &&
              form.controls[question.key].touched
                ? 'is-invalid'
                : ''
            "
            [class]="question.isDisabled ? 'is-disabled' : ''"
          >
            <input
              [id]="question.key + '_search'"
              matInput
              [formControlName]="question.key + '_search'"
              type="text"
              *ngIf="question?.search"
              placeholder="Pesquisar.."
              autocomplete="off"
              (keydown)="keyDownHandler($event, question)"
            />
            <mat-option
              *ngFor="let choice of question.choices"
              [value]="choice.value"
              [disabled]="choice?.disabled || false"
              >{{ choice.title | translate }}</mat-option
            >
          </mat-select>
          <div
            [class]="question?.customIcon?.class"
            *ngIf="question?.customIcon?.icon"
            (click)="emitIconClicked(question)"
          >
            <mat-icon>{{ question?.customIcon?.icon }}</mat-icon>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="question.type === 'textArea'">
        <div class="form-floating field-height">
          <mat-label>{{ question.title | translate }}</mat-label>
          <textarea
            class="form-control textarea-padding"
            [class]="
              !form.controls[question.key].valid &&
              form.controls[question.key].touched
                ? 'is-invalid'
                : ''
            "
            [id]="question.key"
            matInput
            [placeholder]="question.title | translate"
            [formControlName]="question.key"
            [matTooltip]="question?.tooltip?.fieldText | translate"
            [maxlength]="question?.maxLength || null"
          ></textarea>
        </div>
      </ng-container>
      <ng-container
        *ngIf="question.type === 'text' && question?.isVisible !== false"
      >
        <div class="field-height">
          <mat-label
            >{{ question.title | translate }}
            <span *ngIf="question.required" class="danger">*</span></mat-label
          >
          <input
            class="form-control"
            [class]="
              !form.controls[question.key].valid &&
              form.controls[question.key].touched
                ? 'is-invalid'
                : ''
            "
            (keydown)="keyDownHandler($event, question)"
            (keydown)="keyDownHandlerConfirm($event)"
            (blur)="onInputBlur(question)"
            [id]="question.key"
            matInput
            [minlength]="question?.minLength || null"
            [maxlength]="question?.maxLength || null"
            [type]="question?.questionType || 'text'"
            [prefix]="question?.prefix || ''"
            [suffix]="question?.suffix || ''"
            [thousandSeparator]="question?.thousandSeparator || ''"
            [decimalMarker]="question?.decimalMarker || ','"
            [mask]="question?.mask || ''"
            [value]="question.value"
            [formControlName]="question.key"
            [dropSpecialCharacters]="question?.dropSpecialCharacters !== false"
            [allowNegativeNumbers]="question?.allowNegativeNumbers === true"
            [pattern]="question.isEmail ? emailValidation : ''"
            [placeholder]="(question.placeholder | translate) || ''"
            [readonly]="question?.readonly || false"
            [matTooltip]="question?.tooltip?.fieldText | translate"
          />
          <mat-icon
            [matTooltip]="question?.tooltip?.errorText | translate"
            *ngIf="question?.tooltip"
            class="default-tooltip-icon"
            [class]="question?.tooltip?.iconClass || ''"
            aria-hidden="false"
            >{{ question?.tooltip?.icon }}</mat-icon
          >
          <div
            [class]="question?.customIcon?.class"
            *ngIf="question?.customIcon?.icon"
            (click)="emitIconClicked(question)"
          >
            <mat-icon>{{ question?.customIcon?.icon }}</mat-icon>
          </div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="
          question.type === 'autocomplete' && question?.isVisible !== false
        "
      >
        <div class="field-height">
          <mat-label
            >{{ question.title | translate
            }}<span *ngIf="question.required" class="danger m-l-4"
              >*</span
            ></mat-label
          >
          <input
            class="form-control"
            [class]="
              !form.controls[question.key].valid &&
              form.controls[question.key].touched
                ? 'is-invalid'
                : ''
            "
            (keydown)="keyDownHandler($event, question)"
            [id]="question.key"
            matInput
            [minlength]="question?.minLength || null"
            [maxlength]="question?.maxLength || null"
            [type]="question?.questionType || 'text'"
            [value]="question.value"
            [formControlName]="question.key"
            [pattern]="question.isEmail ? emailValidation : ''"
            [placeholder]="(question.placeholder | translate) || ''"
            [matTooltip]="question?.tooltip?.fieldText | translate"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            [id]="question.key + '_auto'"
            [autoActiveFirstOption]="question?.activeFirstOption ?? true"
          >
            <mat-option
              *ngFor="let choice of question.filteredChoices"
              [value]="choice.value"
              [disabled]="choice.value === ''"
            >
              {{ choice.title | translate }}
              <mat-icon
                [matTooltip]="choice?.alertTooltip"
                *ngIf="choice?.isAlert"
                class="mat-icon-alert"
                aria-hidden="false"
                aria-label="Alerta"
                >error_outline</mat-icon
              >
            </mat-option>
          </mat-autocomplete>
        </div>
      </ng-container>
      <ng-container *ngIf="question.type === 'textPassword'">
        <div class="field-height">
          <mat-label>{{ question.title | translate }}</mat-label>
          <input
            class="form-control"
            [class]="
              !form.controls[question.key].valid &&
              form.controls[question.key].touched
                ? 'is-invalid'
                : ''
            "
            [id]="question.key"
            matInput
            [minlength]="question?.minLength || null"
            [maxlength]="question?.maxLength || null"
            [type]="question?.questionType || 'text'"
            [mask]="question?.mask || ''"
            [value]="question.value"
            [matTooltip]="question?.tooltip?.fieldText | translate"
            [placeholder]="(question.placeholder | translate) || ''"
            [formControlName]="question.key"
          />
          <div class="show-hide">
            <button matSuffix (click)="togglePasswordInputType(question)">
              <mat-icon
                color="warning"
                *ngIf="question?.questionType === 'password'"
                >visibility</mat-icon
              >
              <mat-icon
                color="warning"
                *ngIf="question?.questionType === 'text'"
                >visibility_off</mat-icon
              >
            </button>
          </div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="
          question.type === 'datepicker' ||
          question.type === 'datepickerWithCheckbox'
        "
      >
        <div class="field-height">
          <mat-form-field appearance="outline" class="select-field font-inter">
            <mat-label>{{ question.title | translate }}</mat-label>
            <ng-container *ngIf="isStaging || isProduction; else withoutMask">
              <input
                matInput
                [matDatepicker]="picker"
                [formControlName]="question.key"
                [value]="question.value"
                [min]="question?.minDate || null"
                [max]="question?.maxDate || null"
                [mask]="question?.mask || ''"
              />
            </ng-container>
            <ng-template #withoutMask>
              <input
                matInput
                [matDatepicker]="picker"
                [formControlName]="question.key"
                [value]="question.value"
                [min]="question?.minDate || null"
                [max]="question?.maxDate || null"
              />
            </ng-template>
            <mat-datepicker-toggle
              [id]="question.key"
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="row" *ngIf="question.type === 'datepickerWithCheckbox'">
          <mat-checkbox [formControlName]="question.customCheckbox?.key || ''">
            <span class="checkbox-label">
              {{ question.customCheckbox?.title | translate }}
            </span>
          </mat-checkbox>
        </div>
      </ng-container>
      <ng-container *ngIf="question.type === 'multipleSelect'">
        <div class="field-height">
          <mat-form-field
            appearance="outline"
            class="select-field font-inter"
            [floatLabel]="getFloatLabel(question)"
          >
            <mat-label>{{ question.title | translate }}</mat-label>
            <mat-select
              multiple
              [id]="question.key"
              [formControlName]="question.key"
              [value]="question.value"
              [placeholder]="(question.placeholder | translate) || ''"
              [matTooltip]="question?.tooltip?.fieldText | translate"
            >
              <mat-option
                *ngFor="let choice of question.choices"
                [value]="choice.value"
                >{{ choice.title | translate }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </ng-container>
      <ng-container *ngIf="question.type === 'checkbox'">
        <mat-checkbox
          [id]="question.key"
          [formControlName]="question.key"
          [disabled]="question.isDisabled || false"
          type="checkbox"
          color="primary"
          class="checkbox-field"
        >
          <mat-label class="text-gray-medium">
            {{ question.title | translate }}
          </mat-label>
        </mat-checkbox>
      </ng-container>

      <ng-container *ngIf="question.type === 'checkboxgroup'">
        <!-- working  -->
        <div class="d-flex flex-column">
          <mat-checkbox
            *ngFor="let choice of question.choices"
            formControlName="{{ choice.key }}"
            color="primary"
            type="checkbox"
            id="{{ choice.key }}"
            >{{ choice.title | translate }}</mat-checkbox
          >
        </div>
      </ng-container>

      <ng-container
        *ngIf="question.type === 'switch' && question.isVisible !== false"
      >
        <div class="d-flex align-items-center input-switch">
          <mat-label
            [class]="
              question?.customTitleClass
                ? 'mb-0 text-gray-medium ' + question.customTitleClass
                : 'mb-0 text-gray-medium'
            "
            >{{ question.title | translate }}</mat-label
          >
          <input
            [id]="question.key"
            [formControlName]="question.key"
            [disabled]="question.isDisabled || false"
            type="checkbox"
          /><label
            [for]="question.key"
            [style]="
              question.isDisabled
                ? 'pointer-events: none !important; cursor: not-allowed !important; opacity: 0.5 !important;'
                : ''
            "
          ></label>
        </div>
      </ng-container>

      <ng-container
        *ngIf="question.type === 'number' && question?.isVisible !== false"
      >
        <div class="field-height">
          <mat-label
            >{{ question.title | translate
            }}<span *ngIf="question.required" class="danger m-l-4"
              >*</span
            ></mat-label
          >
          <input
            class="form-control"
            [class]="
              !form.controls[question.key].valid &&
              form.controls[question.key].touched
                ? 'is-invalid'
                : ''
            "
            matInput
            [maxlength]="question?.maxLength || null"
            type="number"
            [placeholder]="(question.placeholder | translate) || ''"
            (keydown)="keyDownHandlerConfirm($event)"
            (blur)="onInputBlur(question)"
            [mask]="question?.mask || ''"
            [value]="question.value"
            [formControlName]="question.key"
            [matTooltip]="question?.tooltip?.fieldText | translate"
            min="{{ question?.minRange }}"
            max="{{ question?.maxRange }}"
          /><span *ngIf="question?.suffix" [class]="question?.suffixClass">{{
            question?.suffix
          }}</span>
        </div>
      </ng-container>

      <ng-container
        *ngIf="question.type === 'currency' && question.isVisible !== false"
      >
        <div class="p-t-10">
          <mat-label>
            {{ question.title | translate }}
            <span *ngIf="question.required" class="danger m-l-4"> * </span>
          </mat-label>
          <input
            class="form-control"
            [class]="
              !form.controls[question.key].valid &&
              form.controls[question.key].touched
                ? 'is-invalid'
                : ''
            "
            matInput
            (keydown)="keyDownHandlerConfirm($event)"
            [maxlength]="question?.maxLength || null"
            type="text"
            prefix="R$"
            (blur)="onInputBlur(question)"
            [mask]="question?.mask || ''"
            [allowNegativeNumbers]="false"
            thousandSeparator="."
            [value]="question.value"
            [matTooltip]="question?.tooltip?.fieldText | translate"
            [formControlName]="question.key"
          />
        </div>
      </ng-container>

      <ng-container
        *ngIf="question.type === 'percentage' && question.isVisible !== false"
      >
        <mat-label>{{ question.title | translate }}</mat-label>
        <input
          class="form-control"
          [class]="
            !form.controls[question.key].valid &&
            form.controls[question.key].touched
              ? 'is-invalid'
              : ''
          "
          matInput
          [maxlength]="question?.maxLength || null"
          type="text"
          suffix="%"
          [mask]="question?.mask || ''"
          [allowNegativeNumbers]="false"
          [value]="question.value"
          [formControlName]="question.key"
        />
      </ng-container>

      <ng-container
        *ngIf="
          question.type === 'customInstalation' && question?.isVisible !== false
        "
      >
        <label
          [innerHtml]="question.title | translate"
          class="font-inter"
        ></label>
        <div class="radio radio-primary m-b-10 m-l-10">
          <input
            [formControlName]="question.key"
            [id]="question.title + i"
            type="range"
            [(ngModel)]="question.value"
            min="{{ question?.minRange }}"
            max="{{ question?.maxRange }}"
          />
        </div>
      </ng-container>
      <ng-container
        *ngIf="question.type === 'factorPrice' && question?.isVisible !== false"
      >
        <div class="field-height">
          <mat-label
            >{{ question.title | translate }}
            <span *ngIf="question.required" class="danger">*</span></mat-label
          >
          <input
            class="form-control"
            [class]="
              !form.controls[question.key].valid &&
              form.controls[question.key].touched
                ? 'is-invalid'
                : ''
            "
            [id]="question.key"
            matInput
            type="text"
            mask="separator.2"
            [decimalMarker]="','"
            [value]="question.value"
            [formControlName]="question.key"
            [matTooltip]="question?.tooltip?.fieldText | translate"
          />
          <mat-icon
            [matTooltip]="question?.tooltip?.errorText | translate"
            *ngIf="question?.tooltip"
            class="default-tooltip-icon"
            [class]="question?.tooltip?.iconClass || ''"
            aria-hidden="false"
            >{{ question?.tooltip?.icon }}</mat-icon
          >
          <div
            [class]="question?.customIcon?.class"
            *ngIf="question?.customIcon?.icon"
            (click)="emitIconClicked(question)"
          >
            <mat-icon>{{ question?.customIcon?.icon }}</mat-icon>
          </div>
        </div>
      </ng-container>
      <mat-error
        *ngIf="
          form.controls[question.key].hasError('required') &&
          form.controls[question.key].touched
        "
        class="text text-danger"
        style="margin-top: -1rem"
      >
        * {{ 'Campo obrigatório' | translate }}.
      </mat-error>
      <mat-error
        *ngIf="
          question.minLength &&
          form.controls[question.key].value.length > 0 &&
          form.controls[question.key].value.length < question.minLength &&
          form.controls[question.key].touched
        "
        class="text text-danger"
        style="margin-top: -1rem"
      >
        * {{ 'Mínimo de' | translate }} {{ question.minLength }}
        {{ 'caracteres' | translate }}.
      </mat-error>
      <mat-error
        *ngIf="
          form.controls[question.key].hasError('pattern') &&
          form.controls[question.key].touched
        "
        class="text text-danger"
        style="margin-top: -1rem"
      >
        * {{ 'Por favor, informe um' | translate }}
        {{ question.title | translate }} {{ 'válido' | translate }}.
      </mat-error>
      <mat-error
        *ngIf="
          form.controls[question.key].touched &&
          question.minDate &&
          form.controls[question.key].value !== '' &&
          form.controls[question.key].value < question.minDate
        "
        class="text text-danger"
        style="margin-top: -1rem"
      >
        * {{ 'Por favor, informe uma data maior ou igual a' | translate }}
        {{ question.minDate | date: 'dd/MM/yyyy' }}
      </mat-error>
      <mat-error
        *ngIf="
          form.controls[question.key].touched &&
          question.maxDate &&
          form.controls[question.key].value !== '' &&
          form.controls[question.key].value > question.maxDate
        "
        class="text text-danger"
        style="margin-top: -1rem"
      >
        * {{ 'Por favor, informe uma data menor ou igual a' | translate }}
        {{ question.maxDate | date: 'dd/MM/yyyy' }}
      </mat-error>
      <mat-error
        *ngIf="
          form.controls[question.key].hasError('incorrect') &&
          form.controls[question.key].touched
        "
        class="text text-danger"
        style="margin-top: -1rem"
      >
        * {{ form.controls[question.key].errors?.['message'] | translate }}
      </mat-error>
    </div>
    <ng-content></ng-content>
  </div>
</form>
